// == Import npm
import React from "react";
import { Button, Modal, Form, Input, message } from "antd";
import { useDispatch } from "react-redux";
import { createVisitor } from "services/features/VisitsSlice";

// == Import SCSS
import "./modalAddVisitor.less";

// == import i18n
import { useTranslation } from "react-i18next";

// == Import icons

const ModalAddVisitor = ({ setVisible, isVisible, onCreateUser, setSearch, setSearchValue }) => {
  const [t] = useTranslation();

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const handleAdd = async values => {
    if (
      values.email.toUpperCase().endsWith("pernod-ricard.com") ||
      values.email.toLowerCase().endsWith("pernod-ricard.com")
    ) {
      message.error(t("ErrorResidentAdd"), 5);
    } else {
      const visitor = await dispatch(createVisitor({ ...values, login: values.email }));

      setVisible(false);
      onCreateUser(visitor);
      form.resetFields();
      setSearch("");
      setSearchValue("");
    }
  };

  const handleOk = () => {
    setVisible(false);
    form.resetFields();
    setSearch("");
    setSearchValue("");
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    setSearch("");
    setSearchValue("");
  };

  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: "${label} est obligatoire",
    types: {
      email: "${label} n'est pas un email valide !",
    },
  };
  /* eslint-enable no-template-curly-in-string */

  return (
    <div>
      <Modal width="630px" open={isVisible} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <p className="text">{t("AddAVisitor")}</p>
        <Form
          name="nest-messages"
          validateMessages={validateMessages}
          onFinish={handleAdd}
          form={form}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          layout="horizontal"
        >
          <Form.Item name="firstname" label={t("FirstName")} rules={[{ required: true }]}>
            <Input
              onBlur={() => {
                // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                window.scrollTo(0, 0);
              }}
            />
          </Form.Item>

          <Form.Item name="lastname" label={t("LastName")} rules={[{ required: true }]}>
            <Input
              onBlur={() => {
                // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                window.scrollTo(0, 0);
              }}
            />
          </Form.Item>

          <Form.Item name="phone" label={t("Phone")}>
            <Input
              onBlur={() => {
                // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                window.scrollTo(0, 0);
              }}
            />
          </Form.Item>

          <Form.Item name="company" label={t("Company")}>
            <Input
              onBlur={() => {
                // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                window.scrollTo(0, 0);
              }}
            />
          </Form.Item>

          <Form.Item name="email" label={t("Mail")} rules={[{ type: "email", required: true }]}>
            <Input
              onBlur={() => {
                // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                window.scrollTo(0, 0);
              }}
            />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8 }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              onBlur={() => {
                // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
                window.scrollTo(0, 0);
              }}
            >
              {t("Done")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalAddVisitor;
